import React, { useEffect, useState } from 'react';
import NewUserModal from './NewUserModalProps';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { Pagination, PaginationContent, PaginationItem } from '../../../components/ui/pagination';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Toggle from '../../../components/ui/toggle';
import { usersApi } from '../services/usersApi';
import { User } from '../types/user';

const UsersTable: React.FC = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);

    useEffect(() => {
        usersApi.getUsers().then((data) => {
            setUsers(data as User[]);
        });
    }, []);

    const handleToggle = (id: number, value: string) => {
        setUsers(users => users.map(user => user.id === id ? { ...user, activo: value === 'activo' } : user));
    };

    const handleRowClick = (user: User) => {
        setSelectedUser(user);
        setModalOpen(true);
    };

    return (
        <div>
            <div className="flex items-center justify-end my-5 gap-2">
                <select
                    id="pageSize"
                    className="border border-gray-300 rounded-lg px-3 py-1 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-maxi-green"
                    defaultValue={10}
                >
                    {[10, 20, 30, 50, 100].map(opt => (
                        <option key={opt} value={opt}>{opt}</option>
                    ))}
                </select>
                <label htmlFor="pageSize" className="text-sm text-maxi-text-dark font-medium mr-2">Entradas por página</label>
            </div>
            <div className="bg-white rounded-2xl shadow mb-2 px-2 pt-2 mb-4">
                <Table>
                    <TableHeader>
                        <TableRow className='h-[6vh]'>
                            <TableHead className="text-maxi-text-dark font-semibold">Foto</TableHead>
                            <TableHead className="text-maxi-text-dark font-semibold">Nombre</TableHead>
                            <TableHead className="text-maxi-text-dark font-semibold">Correo</TableHead>
                            <TableHead className="text-maxi-text-dark font-semibold">Teléfono</TableHead>
                            <TableHead className="text-maxi-text-dark font-semibold">Rol</TableHead>
                            <TableHead className="text-maxi-text-dark font-semibold">Estado</TableHead>
                        </TableRow>
                    </TableHeader>
                </Table>
            </div>
            <div className="bg-white rounded-2xl shadow flex flex-1 pb-2 min-h-[60vh]">
                <Table className="divide-y divide-maxi-border ">
                    <TableBody className="border-b border-gray-200">
                        {users.map((user) => (
                            <TableRow key={user.id} className="h-[6vh] hover:bg-gray-100 cursor-pointer" onClick={() => handleRowClick(user)}>
                                <TableCell className="text-maxi-text-dark">
                                    <img src={user.foto} alt={user.nombre} className="w-10 h-10 rounded-full object-cover" />
                                </TableCell>
                                <TableCell className="text-maxi-text-dark">{user.nombre}</TableCell>
                                <TableCell className="text-maxi-text-dark">{user.correo}</TableCell>
                                <TableCell className="text-maxi-text-dark">{user.telefono}</TableCell>
                                <TableCell className="text-maxi-text-dark">{user.rol}</TableCell>
                                <TableCell className="text-maxi-text-dark">
                                    <Toggle
                                        options={[{ label: '', value: 'activo' }, { label: '', value: 'inactivo' }]}
                                        value={user.activo ? 'activo' : 'inactivo'}
                                        onChange={(value) => handleToggle(user.id, value)}
                                        className={user.activo ? '' : 'bg-gray-300'}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
            <div className="flex items-center justify-between px-6 pt-2 pb-2 w-full">
                {modalOpen && selectedUser && (
                    <NewUserModal open={modalOpen} onClose={() => setModalOpen(false)} user={selectedUser} />
                )}
                <span className="text-sm text-maxi-text">Mostrando 1 a 10 de 12 entradas</span>
                <div className="flex-1" />
                <div className="flex items-center gap-2">
                    <Pagination>
                        <PaginationContent className="flex gap-2">
                            <PaginationItem>
                                <button className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-200 hover:bg-muted">
                                    <ChevronLeft className="w-4 h-4" />
                                </button>
                            </PaginationItem>
                            <PaginationItem>
                                <button className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-200 font-semibold text-maxi-text-dark hover:bg-muted">1</button>
                            </PaginationItem>
                            <PaginationItem>
                                <button className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-200 font-semibold text-maxi-text-dark hover:bg-muted">2</button>
                            </PaginationItem>
                            <PaginationItem>
                                <button className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-200 hover:bg-muted">
                                    <ChevronRight className="w-4 h-4" />
                                </button>
                            </PaginationItem>
                        </PaginationContent>
                    </Pagination>
                </div>
            </div>
        </div>
    );
};

export default UsersTable;
